import { pathOr } from 'ramda';

// eslint-disable-next-line import/prefer-default-export
export const authSelector = pathOr(null, ['auth']);
